import React, { useState } from "react";
import { Fields } from "uicomponents";
import { Field } from "formik";
import config from "config";
import EntityForm from "modules/entity/forms";
import get from "lodash/get";
import { ReactComponent as DeleteIcon } from "../../../assets/images/icons/trash.svg?react";
import { ReactComponent as AddIcon } from "../../../assets/images/icons/plus.svg?react";
import CreateProduct from "../SemiFinishedProducts/components/CreateProduct";
import { useDispatch } from "react-redux";
import Actions from "modules/entity/actions";
import useAlert from "../../../hooks/useAlert";
import useTranslation from "../../../hooks/useTranslation";

const ConsumptionModal = ({ showConsumptionModal, setCanUpdate }) => {
	const { tr } = useTranslation();

	const { showAlert } = useAlert();
	const dispatch = useDispatch();
	const [createModal, showCreateModal] = useState(false);
	const [items, setItems] = useState([]);
	const [isSubmitting, setSubmitting] = useState(false);

	const deleteAction = item => {
		const arr = items.filter(p => p.id !== item.id);
		setItems(arr);
	};

	const submitHandler = () => {
		setSubmitting(true);
		dispatch(
			Actions.FormDefault.request({
				method: "post",
				url: "/consumptions",
				values: {
					data: items.reduce(
						(prev, curr) => [
							...prev,
							{
								storage_id: curr.storage.id,
								product_id: curr.product.id,
								quantity: curr.quantity
							}
						],
						[]
					),
					type: 1
				},
				cb: {
					success: () => {
						showConsumptionModal(false);
						setCanUpdate(prev => !prev);
					},
					error: response => {
						showAlert(get(response, "errorMessage", ""), { type: "danger" });
					},
					finally: () => {
						setSubmitting(false);
					}
				}
			})
		);
	};
	return (
		<div className="">
			<div className="modal-title">{tr("Добавить расход")}</div>
			<div className="modal-body pos-relative">
				<EntityForm.Default
					method="post"
					url="/"
					params={{
						include: "product.unit,outputProduct.unit"
					}}
					fields={[
						{
							name: "required",
							required: true
						},
						// {
						// 	name: "type",
						// 	value: config.CATEGORY_MATERIAL
						// },
						{
							name: "product_id",
							onSubmitValue: value => value.id
						},
						{
							name: "storage_id",
							onSubmitValue: value => value.id
						},
						{
							name: "quantity",
							value: ""
						}
					]}
				>
					{({ isSubmitting, values, setFieldValue, errors }) => {
						const cbSuccess = data => {
							setFieldValue("product_id", data);
						};
						return (
							<div>
								<div className="row">
									<CreateProduct
										{...{
											createModal,
											showCreateModal,
											cbSuccess,
											// type: values.type
										}}
									/>
									<div className="col-3">
										<Field
											component={Fields.AsyncSelectS1}
											type="text"
											name={"storage_id"}
											label={tr("Склад")}
											placeholder={tr("Выберите склад")}
											loadOptionsUrl={"/storages"}
											optionLabel={"name"}
											isSearchable={true}
											size={"small"}
											className={"mb-20"}
											loadOptionsParams={search => {
												return {
													sort: "name"
												};
											}}
										/>
									</div>
									{/* <div className="col-3">
										<Field
											component={Fields.SelectS1}
											name={"type"}
											label={tr("Тип")}
											placeholder={tr("Выберите")}
											size={"small"}
											optionValue={"value"}
											optionLabel={"label"}
											options={[
												{ value: config.CATEGORY_MATERIAL, label: tr("Сырьё") },
												{
													value: config.CATEGORY_HALF_FINISHED,
													label: tr("Полуфабрикат")
												},
												{
													value: config.CATEGORY_PRODUCT,
													label: tr("Реализация")
												}
											]}
										/>
									</div> */}
									<div className="col-3">
										<Field
											canUpdate={values.type}
											component={Fields.AsyncSelectS1}
											type="text"
											name={"product_id"}
											label={tr("Товар")}
											placeholder={tr("Выберите")}
											loadOptionsUrl={"/products"}
											optionLabel={"name"}
											isSearchable={true}
											size={"small"}
											className={"mb-20"}
											loadOptionsParams={search => {
												return {
													// filter: { type: values.type },
													extra: { _query: search },
													limit: 50,
													include: "unit"
												};
											}}
											loadOptionsKey={data => {
												return get(data, "current_page") === 1
													? [
														{
															id: 0,
															name: (
																<div className="select_add_option">
																	<AddIcon />
																	<span>{tr("Добавить новый")}</span>
																</div>
															)
														},
														...get(data, "data", [])
													]
													: [...get(data, "data", [])];
											}}
											handleChange={option => {
												if (option.id === 0) {
													setFieldValue("product_id", null);
													showCreateModal(true);
												}
											}}
										/>
									</div>
									<div className="col-3">
										<div className="d-flex align-items-end">
											<Field
												component={Fields.InputS1}
												name="quantity"
												type="number"
												className={"mb-0"}
												placeholder={tr("Кол-во")}
												label={tr("Кол-во")}
												size={"small"}
												isRequired={true}
												prependData={
													<>
														<div className="form-field__prepend">
															{get(values, "product_id.unit.short_name")}
														</div>
													</>
												}
											/>
											<button
												disabled={
													!values.quantity ||
													!values.product_id ||
													!values.storage_id
												}
												type={"button"}
												className={`ml-10 d-btn d-btn--small fs-14 d-btn-primary`}
												onClick={e => {
													setItems([
														{
															product: values.product_id,
															quantity: values.quantity,
															storage: values.storage_id
														},
														...items
													]);
													setFieldValue("product_id", null);
													setFieldValue("quantity", "");
												}}
											>
												{tr("Добавить")}
											</button>
										</div>
									</div>
								</div>
							</div>
						);
					}}
				</EntityForm.Default>

				{items.length > 0 && (
					<>
						<div className="default-table-wrap">
							<table className="default-table default-table-hover">
								<thead>
									<tr>
										<th className="w-50 text-cen">№</th>
										<th>{tr("Продукт")}</th>
										<th className="text-right">{tr("Кол-во")}</th>
										<th className="w-100"></th>
									</tr>
								</thead>
								<tbody>
									{items.map((item, ind) => {
										return (
											<tr>
												<td className="w-50 text-cen">{ind + 1}</td>
												<td>{get(item, "product.name")}</td>
												<td className="text-right">
													{get(item, "quantity") +
														" " +
														get(item, "product.unit.short_name")}
												</td>
												<td className="w-100 pad-0">
													<div className="d-flex justify-content-center">
														<span
															className="action-btn action-btn--danger"
															onClick={() => deleteAction(item)}
														>
															<DeleteIcon />
														</span>
													</div>
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
						<button
							disabled={isSubmitting}
							type={"button"}
							className={`${isSubmitting ? "--loading" : ""
								} w-100p justify-content-center mt-30 d-btn d-btn--small fs-14 d-btn-primary`}
							onClick={submitHandler}
						>
							{tr("Создать расход")}
						</button>
					</>
				)}
			</div>
		</div>
	);
};

export default ConsumptionModal;
